import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { TutorStudentSearchTemplate } from '@/features/tutor-ai';

export const Route = createFileRoute('/_authenticated/tutor-ai/students/')({
  component: TutorStudentSearchPage,
});

/** Página de busca de aluno para o relatório de uso do tutor. */
export function TutorStudentSearchPage() {
  const navigate = useNavigate();

  return (
    <TutorStudentSearchTemplate
      onSelectStudent={personId =>
        void navigate({
          to: '/tutor-ai/students/$personId',
          params: { personId: String(personId) },
        })
      }
    />
  );
}
